export default "__VITE_ASSET__D4D483yI__"